import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";

import { apiClient } from "utils/apiClient";
import { getErrorMessage } from "utils/errorUtils";

import { getToken, localStorageShowConfirmNotifyBuddy } from "auth/helpers/authApi";

import { BuddyDetailsContext, BuddyDetails } from "../buddy-details";

export const BuddyDetailsProvider = ({ children }) => {
	const { enqueueSnackbar } = useSnackbar();
	const intl = useIntl();

	const [details, setDetails] = useState<BuddyDetails | undefined>();
	const [detailsLoading, setDetailsLoading] = useState(false);
	const [notifyLoading, setNotifyLoading] = useState(false);
	const [openDetails, setOpenDetails] = useState(false);
	const [openConfirm, setOpenConfirm] = useState(false);

	useEffect(() => {
		const getBuddyDetails = async () => {
			setDetailsLoading(true);
			try {
				const res = await apiClient("employees/buddy/mentor", { token: getToken() });
				if (res?.message === "Success") {
					setDetails(res.data);
				}
			} catch (error) {
			} finally {
				setDetailsLoading(false);
			}
		};

		getBuddyDetails();
	}, []);

	const notifyBuddy = async () => {
		setNotifyLoading(true);
		try {
			const res = await apiClient("employees/buddy/notify", { token: getToken(), method: "POST" });
			if (res?.message === "Success") {
				localStorage.setItem(localStorageShowConfirmNotifyBuddy, "hide");
			}
			setOpenDetails(false);
			enqueueSnackbar(
				intl.formatMessage({
					id: "USER-DASHBOARD.notify-buddy.success",
				}),
				{
					variant: "success",
				},
			);
		} catch (error) {
			let message = intl.formatMessage({
				id: "DASHBOARD.employee-journey.create_error",
			});
			const errorJson = (error as any).json;
			if (errorJson?.code) {
				message = getErrorMessage(errorJson.code);
			}
			enqueueSnackbar(message, {
				variant: "error",
			});
		} finally {
			setNotifyLoading(false);
			setOpenConfirm(false);
		}
	};

	const value = {
		details,
		setDetails,
		detailsLoading,
		setDetailsLoading,
		openDetails,
		setOpenDetails,
		openConfirm,
		setOpenConfirm,
		notifyLoading,
		setNotifyLoading,
		notifyBuddy,
	};

	return <BuddyDetailsContext.Provider value={value}>{children}</BuddyDetailsContext.Provider>;
};
